import addValidationMessage from '../utils/translation/addValidationMessage';

addValidationMessage('Core/requiredFileValidator', 'requiredFile', {
  fr: 'Au moins un fichier requis',
  en: 'At least one file required',
});

const requiredFileValidator = (value: File[], { required: isRequired = true } = {}) => (
  !isRequired || (
    Array.isArray(value) &&
    value.length > 0
  )
);

/**
 * @component
 * @visibleName requiredFileValidator
 */
export default requiredFileValidator;
